import { Navigate, useLocation, useParams } from "react-router-dom";
import type { LegacyPageRedirect as Redirect } from "./legacyPageRedirects";

export const LegacyPageRedirect = ({ redirect }: { redirect: Redirect }) => {
  const params = useParams();
  const location = useLocation();
  const target = redirect.to(params, new URLSearchParams(location.search));
  const kept = redirect.keepQuery ? `${location.search}${location.hash}` : "";
  return <Navigate to={`${target}${kept}`} replace />;
};
